import React, { ChangeEvent, useEffect, useState } from 'react';
import './NavBar.style.scss';
import { useNavigate } from 'react-router-dom';
import { RoutesNames } from '#/router/routes';
import ThemeToggle from '#/components/form/ThemeToggle';
import useTheme from '#/hooks/useTheme';

const NavBar = () => {
  const navigate = useNavigate();

  const { retrieveTheme, storeTheme } = useTheme();

  const [theme, setTheme] = useState(retrieveTheme());

  const handleThemeChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.checked) {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  };

  const goToHome = () => navigate(RoutesNames.HOME);

  const goToCharacters = () => navigate(RoutesNames.CHARACTERS);

  const goToComics = () => navigate(RoutesNames.COMICS);

  const goToStories = () => navigate(RoutesNames.STORIES);

  const goToBookmarks = () => navigate(RoutesNames.BOOKMARKS);

  useEffect(() => {
    if (theme) {
      storeTheme(theme);
    }
  }, [storeTheme, theme]);

  return (
    <nav className="navBar">
      <span onClick={goToHome}>FAKE MARVEL</span>

      <div>
        <ul>
          <li onClick={goToHome}>
            <span className="material-icons">home</span>
            <span className="menu--item">Home</span>
          </li>

          <li onClick={goToCharacters}>
            <span className="material-icons">group</span>
            <span className="menu--item">Characters</span>
          </li>

          <li onClick={goToComics}>
            <span className="material-icons">menu_book</span>
            <span className="menu--item">Comics</span>
          </li>

          <li onClick={goToStories}>
            <span className="material-icons">history_edu</span>
            <span className="menu--item">Stories</span>
          </li>

          <li onClick={goToBookmarks}>
            <span className="material-icons">star</span>
            <span className="menu--item">Bookmarks</span>
          </li>
        </ul>
        <ThemeToggle checked={theme === 'dark'} onChange={handleThemeChange} />
      </div>
    </nav>
  );
};

export default React.memo(NavBar);
